import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import Slider from "react-slick";
import eventImageFallback from "../images/events/event-4.jpg";
import { formatDate } from '../utils/format-date';
import '../stylesheets/components/reports.scss';

export default function Reports_widget(props) {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        draggable: false,
        swipe: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 767, settings: { slidesToShow: 3, vertical: true} },
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 100000, settings: { slidesToShow: 3 } }
        ]
    };

    return (
        <>
            <StaticQuery
                query={graphql`query FeaturedReports{
                    allNodeDarReports(limit: 3, sort: {fields: created, order: DESC}, filter:{field_featured: {eq: true}}) {
                        edges {
                            node {
                                field_link_to_full_report {
                                    uri
                                },
                                title,
                                field_date_of_report,
                                field_featured,
                                field_date_display_format,
                                field_image {
                                    alt
                                }
                                path {
                                    alias
                                }
                                relationships {
                                    field_image {
                                        localFile {
                                            childImageSharp {
                                                gatsbyImageData(layout: CONSTRAINED)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }    
                }
            `}
                render={data => {
                    const featuredReports = data.allNodeDarReports.edges.sort((a, b) => new Date(b.node.field_date_of_report) - new Date(a.node.field_date_of_report))
                    const showMoreButton = props.field_see_more_reports_button
                    const mainClass = showMoreButton ? 'blog-posts reports' : 'blog-posts reports featured-reports-non-homepage'
                    return (
                        <section className={mainClass}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h2>Featured research</h2>
                                        {featuredReports?.length === 0 ? <div>There are no featured reports at this time. Please come back later.</div> : <></>}
                                    </div>
                                </div>
                                <div className="parrent">
                                    <Slider {...settings}>
                                        {
                                            featuredReports.map((featuredReport, index) =>
                                                <div key={index} className='col-parrent'>
                                                    <div className='col'>
                                                        <div className="img-holder">
                                                            <Link aria-label={featuredReport.node.title} to={featuredReport.node.path.alias}>
                                                                <div className="image-container">
                                                                    {
                                                                        featuredReport.node.relationships.field_image ?
                                                                            <GatsbyImage image={featuredReport.node.relationships.field_image.localFile.childImageSharp.gatsbyImageData}
                                                                                alt={featuredReport.node.field_image.alt} /> :
                                                                            <img src={eventImageFallback} alt="Report" />
                                                                    }
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="details-holder">
                                                            <h3>
                                                                <Link to={featuredReport.node.path.alias}>{featuredReport.node.title}</Link>
                                                            </h3>
                                                            <small>{formatDate(featuredReport.node.field_date_of_report, featuredReport.node.field_date_display_format)}</small>
                                                        </div>
                                                    </div>
                                                </div>)
                                        }
                                    </Slider>
                                </div>
                                {showMoreButton && (
                                    <div className="row">
                                        <div className="col-sm-12 text-center">
                                            <Link className="btn btn-blue btn-lg" to="/about/reports-and-insights">See more research</Link>
                                        </div>
                                    </div>)
                                }
                            </div>
                        </section>
                    )
                }}
            />
        </>
    )
}

export const ReportsWidgetQuery = graphql`
fragment ParagraphsReportsWidget on paragraph__reports_widget {
    field_see_more_reports_button
}
`